module.exports = __webpack_public_path__ + "static/media/facebook.f6c66255.png";